import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowToPlaySection from './components/HowToPlaySection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <HowToPlaySection />
      <CTASection />
      <Footer />
    </main>
  );
}
